// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerCarteApi } from "../../services/Api/CustomerCartApi"
import { getCartList,getErrors } from "../reducers/CartListReducer"

// Watchers
function* CartListSaga() {
	yield takeEvery("cart_list/getCart", getCustomerCartList)
}

// Sagas
function* getCustomerCartList(action) {
	// console.log(action, "cart")
	// try {
	// 	const getCartProducts = yield call(getCustomerCarteApi, action.payload)
	// 	// console.log(getProducts,"ldfgsdgb")

	// 	if (getCartProducts.request.status === 200) {
	// 		yield put(getCartList(getCartProducts))
	// 	} else {
	// 		yield put(getErrors(true))
	// 	}
	// } catch (error) {
	// 	// console.log(error,"otp error")
	// 	yield put(getErrors(error))
	// }
}

export default function* rootSaga() {
	yield all([fork(CartListSaga)])
}
